import React, { createContext } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { store } from 'store/store';
import { App } from 'pages/App';

import './index.css';

const root = createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <BrowserRouter basename='/prokeyweb'>
      <App />
    </BrowserRouter>
  </Provider>
);
